import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../../components";
import { envChangeType } from "../../../../plugins/utils";
import styles from "./style.module.scss";

const Greener = ({ imageLeft, id = "greener" }) => {
  const { t } = useTranslation();

  const imageEnum = {
    greener: {
      src: `/images/home/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/greener/tree.png`,
      href: "/blog",
    },
    contract: {
      src: `/images/home/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/greener/contract.png`,
      href: "/project",
    },
  };
  return (
    <div className={styles.greener}>
      {imageLeft ? (
        <>
          <div className={styles.right}>
            <Image src={imageEnum[id].src} alt="tree" preview={false} className={styles.img} />
          </div>
          <div className={styles.left}>
            <div className={styles.extra}>{t(`home.${id}.extra`)}</div>
            <div className={styles.title}>{t(`home.${id}.title`)}</div>
            <div className={styles.subTitle}>{t(`home.${id}.subTitle`)}</div>
            <CustomButton
              buttonStyle={`${styles.customButtonStyle}`}
              onClick={() => (window.location.href = imageEnum[id].href)}
            >
              {t(`home.${id}.btn`)}
            </CustomButton>
          </div>
        </>
      ) : (
        <>
          <div className={styles.left}>
            <div className={styles.extra}>{t(`home.${id}.extra`)}</div>
            <div className={styles.title}>{t(`home.${id}.title`)}</div>
            <div className={styles.subTitle}>{t(`home.${id}.subTitle`)}</div>
            <CustomButton
              buttonStyle={`${styles.customButtonStyle}`}
              onClick={() => (window.location.href = imageEnum[id].href)}
            >
              {t(`home.${id}.btn`)}
            </CustomButton>
          </div>
          <div className={styles.right}>
            <Image src={imageEnum[id].src} alt="tree" preview={false} className={styles.img} />
          </div>
        </>
      )}
    </div>
  );
};

export default Greener;
